import React, { cloneElement } from 'react';

import s from './Gallery.scss';

interface IGalleryProps {
  children: React.ReactElement;
  ratio?: 'portrait' | 'landscape';
}

export const GalleryItem = ({ children, ratio = 'landscape' }: IGalleryProps) => (
  <div className={s('gallery__item', ratio )}>
    {cloneElement(children, {
      className: s.gallery__image,
    })}
  </div>
);

